const progressSteps5 = [25, 50, 75, 87, 98];
const progressSteps7 = [25, 50, 65, 75, 85, 92, 98];
const progressSteps10 = [25, 40, 55, 65, 72, 79, 85, 91, 95, 98];

const getProgressSteps = (maxProgressStepsCount: number) => {
  if (maxProgressStepsCount > 0 && maxProgressStepsCount <= 5) {
    return progressSteps5;
  }

  if (maxProgressStepsCount > 5 && maxProgressStepsCount <= 7) {
    return progressSteps7;
  }

  if (maxProgressStepsCount > 7 && maxProgressStepsCount <= 10) {
    return progressSteps10;
  }

  return progressSteps10;
};

export const calcSurveyProgress = (answeredQuestionCount: number, finished: boolean, maxProgressStepsCount?: number) => {
  if (!maxProgressStepsCount) {
    return 0;
  }

  if (finished) {
    return 100;
  }

  const progressSteps = getProgressSteps(maxProgressStepsCount);

  if (answeredQuestionCount < progressSteps.length) {
    return progressSteps[answeredQuestionCount];
  }

  return 98;
};
